// ConnectionBadge：4 态连接指示（🟢🟡🔴⛔ 是 functional indicator，非装饰）。
// daemon_down 时点击给一个简易提示，引导用户重试或检查 daemon 进程。

import { useState } from "react";
import { useConnectionStatus, type ConnectionState } from "@/hooks/useConnectionStatus";

const LABEL: Record<ConnectionState, string> = {
  live: "实时",
  reconnecting: "重连中",
  offline: "离线",
  daemon_down: "daemon 断开",
};

const ICON: Record<ConnectionState, string> = {
  live: "🟢",
  reconnecting: "🟡",
  offline: "🔴",
  daemon_down: "⛔",
};

export function ConnectionBadge() {
  const { state, retry } = useConnectionStatus();
  const [open, setOpen] = useState(false);
  const clickable = state === "daemon_down" || state === "offline";

  return (
    <div className="relative text-xs">
      <button
        type="button"
        className="inline-flex items-center gap-1.5 rounded px-2 py-1 hover:bg-[hsl(var(--muted))]"
        onClick={() => (clickable ? setOpen((v) => !v) : undefined)}
        aria-label={`连接状态：${LABEL[state]}`}
      >
        <span aria-hidden="true">{ICON[state]}</span>
        <span>{LABEL[state]}</span>
      </button>
      {open && clickable ? (
        <div
          className="absolute bottom-full left-0 mb-2 w-56 rounded border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-3 shadow"
          role="dialog"
        >
          <div className="text-[hsl(var(--foreground))]">
            {state === "daemon_down"
              ? "daemon 健康检查连续失败。请检查 daemon 进程或网络。"
              : "事件流心跳超时。SSE 可能被中间层缓冲。"}
          </div>
          <button
            type="button"
            className="mt-2 underline"
            onClick={() => {
              retry();
              setOpen(false);
            }}
          >
            重试连接
          </button>
        </div>
      ) : null}
    </div>
  );
}
